<template>
  <div class="spine-config-page">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/menu/welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>内容管理</el-breadcrumb-item>
      <el-breadcrumb-item>脊柱侧弯配置</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card class="box-card" v-loading="loading">
      <div slot="header" class="clearfix">
        <span>健康顺德脊柱侧弯康复 H5 配置</span>
        <el-button style="float: right; margin-left: 8px" type="primary" size="small" @click="saveConfig">保存配置</el-button>
        <el-button style="float: right" size="small" @click="loadConfig">重新加载</el-button>
      </div>

      <el-form label-width="120px" :model="config">
        <el-form-item label="中心名称">
          <el-input v-model="config.hospital.name" placeholder="请输入中心名称" />
        </el-form-item>
        <el-form-item label="主图 URL">
          <el-input v-model="config.hospital.mainImg" placeholder="请输入主图 URL" />
        </el-form-item>
        <el-form-item label="视频分类">
          <el-input v-model="config.courseSort" placeholder="请输入 courseSort，例如 29G" style="width: 280px" />
        </el-form-item>
      </el-form>

      <el-divider content-position="left">首页 Banner</el-divider>
      <el-table :data="config.hospital.bannerList" border size="small" empty-text="暂无 Banner">
        <el-table-column label="标题" min-width="120">
          <template slot-scope="scope"><el-input v-model="scope.row.title" size="small" /></template>
        </el-table-column>
        <el-table-column label="图片 URL" min-width="240">
          <template slot-scope="scope"><el-input v-model="scope.row.img" size="small" /></template>
        </el-table-column>
        <el-table-column label="跳转分类 Key" min-width="180">
          <template slot-scope="scope"><el-input v-model="scope.row.targetCategoryKey" size="small" placeholder="例如 spine_screening" /></template>
        </el-table-column>
        <el-table-column label="操作" width="90" align="center">
          <template slot-scope="scope"><el-button type="text" style="color:#F56C6C" @click="removeBanner(scope.$index)">删除</el-button></template>
        </el-table-column>
      </el-table>
      <el-button type="primary" plain size="small" style="margin-top: 10px" @click="addBanner">添加 Banner</el-button>

      <el-divider content-position="left">专家团队</el-divider>
      <el-table :data="config.hospital.doctors" border size="small" empty-text="暂无团队">
        <el-table-column label="名称" min-width="160">
          <template slot-scope="scope"><el-input v-model="scope.row.name" size="small" /></template>
        </el-table-column>
        <el-table-column label="图片 URL" min-width="260">
          <template slot-scope="scope"><el-input v-model="scope.row.img" size="small" /></template>
        </el-table-column>
        <el-table-column label="操作" width="90" align="center">
          <template slot-scope="scope"><el-button type="text" style="color:#F56C6C" @click="removeDoctor(scope.$index)">删除</el-button></template>
        </el-table-column>
      </el-table>
      <el-button type="primary" plain size="small" style="margin-top: 10px" @click="addDoctor">添加团队</el-button>

      <el-divider content-position="left">JSON 预览</el-divider>
      <el-input type="textarea" :rows="12" :value="configJsonText" readonly />
    </el-card>
  </div>
</template>

<script>
const defaultConfig = () => ({
  hospital: {
    id: 'shunyi001',
    name: '健康顺德脊柱侧弯康复中心',
    mainImg: 'https://cdn.keihong.tech/img/202412091556356.png',
    bannerList: [],
    doctors: []
  },
  courseSort: '29G'
})

const legacyBannerCategoryMap = {
  early_detection: 'spine_screening',
  rehabilitation: 'spine_rehabilitation',
  prevention: 'spine_daily_prevention'
}

export default {
  name: 'SpineConfig',
  data () {
    return {
      loading: false,
      configKey: 'shunyi_home',
      config: defaultConfig()
    }
  },
  computed: {
    configJsonText () {
      return JSON.stringify(this.buildConfigPayload(), null, 2)
    }
  },
  mounted () {
    this.loadConfig()
  },
  methods: {
    normalizeConfig (raw) {
      const config = Object.assign(defaultConfig(), raw || {})
      config.hospital = Object.assign(defaultConfig().hospital, config.hospital || {})
      config.hospital.bannerList = (config.hospital.bannerList || []).map(item => ({
        title: item.title || '',
        img: item.img || '',
        targetCategoryKey: item.targetCategoryKey || legacyBannerCategoryMap[item.category] || ''
      }))
      config.hospital.doctors = config.hospital.doctors || []
      return config
    },
    async loadConfig () {
      this.loading = true
      try {
        const { data: resp } = await this.$http.get('/cms/spine/config/load', { params: { configKey: this.configKey } })
        if (resp.code === 200 && resp.data && resp.data.configJson) {
          this.config = this.normalizeConfig(JSON.parse(resp.data.configJson))
        } else {
          this.config = defaultConfig()
        }
      } catch (e) {
        console.error('加载脊柱侧弯配置失败', e)
        this.$message.error('加载配置失败')
      } finally {
        this.loading = false
      }
    },
    async saveConfig () {
      this.loading = true
      try {
        const { data: resp } = await this.$http.post('/cms/spine/config/save', this.configJsonText, {
          params: { configKey: this.configKey },
          headers: { 'Content-Type': 'application/json' }
        })
        if (resp.code === 200) {
          this.$message.success('保存成功')
        } else {
          this.$message.error(resp.message || '保存失败')
        }
      } catch (e) {
        console.error('保存脊柱侧弯配置失败', e)
        this.$message.error('保存配置失败')
      } finally {
        this.loading = false
      }
    },
    buildConfigPayload () {
      return {
        hospital: Object.assign({}, this.config.hospital, {
          bannerList: this.config.hospital.bannerList.map(item => ({
            title: item.title || '',
            img: item.img || '',
            targetCategoryKey: item.targetCategoryKey || ''
          })),
          doctors: this.config.hospital.doctors || []
        }),
        courseSort: this.config.courseSort || ''
      }
    },
    addBanner () {
      this.config.hospital.bannerList.push({ title: '', img: '', targetCategoryKey: '' })
    },
    removeBanner (index) {
      this.config.hospital.bannerList.splice(index, 1)
    },
    addDoctor () {
      this.config.hospital.doctors.push({ name: '', img: '' })
    },
    removeDoctor (index) {
      this.config.hospital.doctors.splice(index, 1)
    }
  }
}
</script>

<style scoped>
.spine-config-page {
  padding: 16px;
}
.box-card {
  margin-top: 16px;
}
</style>
